import _classCallCheck from "/Users/phil/Workspace/petroff-billing-master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/phil/Workspace/petroff-billing-master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
var LoginService = /*#__PURE__*/function () {
  function LoginService(https, userStorage, clientConfig) {
    _classCallCheck(this, LoginService);
    this.https = https;
    this.userStorage = userStorage;
    this.clientConfig = clientConfig;
  }
  _createClass(LoginService, [{
    key: "login",
    value: function login(username, password, newPassword, firstname) {
      var _this = this;
      var self = this;
      var body = {
        username: username,
        password: password,
        newPassword: newPassword,
        firstname: firstname,
        company: this.clientConfig.deployment
      };
      return new Promise(function (resolve, reject) {
        _this.https.post('/auth/login', body).then(function (data) {
          if (data.token) {
            self.userStorage.setAccessToken(data.token);
            self.userStorage.setLoggedInUser(username);
          }
          resolve(data);
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "logout",
    value: function logout(username) {
      var _this2 = this;
      var body = {
        username: username
      };
      return new Promise(function (resolve, reject) {
        _this2.https.post('/auth/logout', body).then(function (data) {
          resolve(data);
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "forgotPassword",
    value: function forgotPassword(email, callback) {
      var body = {
        email: email
      };
      this.https.post('/auth/forgotPassword', body).then(function (response) {
        callback(response);
      }).catch(function (error) {
        console.log('error: ', error);
      });
    }
  }, {
    key: "confirmForgotPassword",
    value: function confirmForgotPassword(username, verificationCode, newPassword, callback) {
      var body = {
        username: username,
        verificationCode: verificationCode,
        newPassword: newPassword
      };
      this.https.post('/auth/confirmForgotPassword', body).then(function (response) {
        callback(response);
      }).catch(function (error) {
        console.log('error:', error);
      });
    }
  }]);
  return LoginService;
}();
export default LoginService;